import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { Store as StoreType } from '../../services/authService';

interface StoreInfoProps {
  storeData: StoreType | null;
  totalPacks: number;
}

export const StoreInfo: React.FC<StoreInfoProps> = ({ storeData, totalPacks }) => {
  return (
    <Box>
      {storeData && (
        <Box>
          <Typography variant="body1" color="#222B45" fontWeight={600} fontSize={24}>
            {storeData.name}
          </Typography>
          {(storeData.address_line1 || storeData.address) && (
            <Typography variant="body1" color="#222B45" fontSize={15} fontWeight={400}>
              {storeData.address_line1 || storeData.address}
              {storeData.address_line2 && `, ${storeData.address_line2}`}
              {storeData.city && `, ${storeData.city}`}
              {storeData.state && `, ${storeData.state}`}
              {(storeData.postal_code || storeData.zip_code) && ` ${storeData.postal_code || storeData.zip_code}`}
              {storeData.country && `, ${storeData.country}`}
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" fontSize={15} fontWeight={500}>
            Store Key: {storeData.store_key} Activated Packs: {totalPacks}
          </Typography>
        </Box>
      )}
    </Box>
  );
}; 